import { useNavigate } from 'react-router-dom'
import { IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

import { IColumnActionProps } from '../../../shared/interfaces/datagrid.interface'

const ApprovalActionButton = ({ slug }: IColumnActionProps) => {
  const navigate = useNavigate()

  const onClickHandler = () => {
    navigate(`/approvals/${slug}/information`)
  }

  return (
    <IconButton color='primary' onClick={onClickHandler}>
      <VisibilityIcon />
    </IconButton>
  )
}

export default ApprovalActionButton
